module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm2": ""
    }
  }, [_c('h4', [_vm._v("Create a new Trial")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm2": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateTrial($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "title",
      "label": "Title",
      "id": "title",
      "required": ""
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "description",
      "label": "Description",
      "id": "description",
      "multi-line": "",
      "required": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialEnrollment",
      "label": "Add Trial Enrollments",
      "items": _vm.enrollments,
      "item-value": "enrollmentId",
      "item-text": "enrollmentName",
      "id": "trialEnrollment",
      "max-height": "400",
      "hint": "Pick your enrollments",
      "persistent-hint": "",
      "required": ""
    },
    model: {
      value: (_vm.trialEnrollment),
      callback: function($$v) {
        _vm.trialEnrollment = $$v
      },
      expression: "trialEnrollment"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialLocations",
      "label": "Add Trial Locations",
      "items": _vm.locations,
      "item-value": "locationId",
      "item-text": "locationName",
      "id": "trialLocations",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your locations",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialLocations),
      callback: function($$v) {
        _vm.trialLocations = $$v
      },
      expression: "trialLocations"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialIndications",
      "label": "Add Trial Indications",
      "items": _vm.indications,
      "item-value": "indicationId",
      "item-text": "indicationName",
      "id": "trialIndications",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your indications",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialIndications),
      callback: function($$v) {
        _vm.trialIndications = $$v
      },
      expression: "trialIndications"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialCoordinators",
      "label": "Add Trial Coordinators",
      "items": _vm.coordinators,
      "item-value": "coordinatorId",
      "item-text": "coordinatorName",
      "id": "trialCoordinators",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your Coordinators",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialCoordinators),
      callback: function($$v) {
        _vm.trialCoordinators = $$v
      },
      expression: "trialCoordinators"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-select', {
    attrs: {
      "name": "trialInvestigators",
      "label": "Add Trial Investigators",
      "items": _vm.investigators,
      "item-value": "investigatorId",
      "item-text": "investigatorName",
      "id": "trialInvestigators",
      "multiple": "",
      "max-height": "400",
      "hint": "Pick your Investigators",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.trialInvestigators),
      callback: function($$v) {
        _vm.trialInvestigators = $$v
      },
      expression: "trialInvestigators"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "trialLink",
      "label": "Link",
      "id": "trialLink",
      "required": ""
    },
    model: {
      value: (_vm.trialLink),
      callback: function($$v) {
        _vm.trialLink = $$v
      },
      expression: "trialLink"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Trial\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c1038e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/CreateTrial.vue
// module id = 659
// module chunks = 1